import passwordPolicy from './passwordPolicy'

export default passwordPolicy



// WEBPACK FOOTER //
// ./src/passwordPolicy/index.js